import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export type NativeSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

const nativeSelectClass =
  "w-full h-9 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/10";

export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, ...props }, ref) => (
    <select ref={ref} className={cn(nativeSelectClass, className)} {...props} />
  ),
);

NativeSelect.displayName = "NativeSelect";
